import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormsModule,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Table } from 'primeng/table';
import { TableService } from '../../../_services/table.service';
import { ActivatedRoute, Router } from '@angular/router';
// import { AuthenticationService } from '../../_services';
import { ToastModule } from 'primeng/toast';
import { DatasearchService } from '../../../_services/datasearch.service';
import {
  ConfirmationService,
  LazyLoadEvent,
  MessageService,
} from 'primeng/api';

import { DatePipe } from '@angular/common';
import { BusyService } from '../../../_services/busy.service';
import { ExportDataService } from '../../../_services/export-data.service';
import { user_privilege } from '../../../../_model/user_privilege';
import { search_filter } from '../../../../_model/search_fliter';
import { Dialog } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { HighlightDirective } from '../../../_directives/highlight.directive';

import { DialogModule } from 'primeng/dialog';
import { BadgeModule } from 'primeng/badge';
import { InputNumberModule } from 'primeng/inputnumber';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { NoRecordComponent } from '../no-record/no-record.component';
// import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { GlobalService } from '../../../_services/global.service';
import { TooltipModule } from 'primeng/tooltip';
import { CardViewComponent } from '../ipd-table-section/card-view/card-view.component';
import { DetailViewComponent } from '../ipd-table-section/detail-view/detail-view.component';
import { companydirectory_model } from '../../../../_model/companydirectory_model';
import { ConstantService } from '../../../_services/constant.service';
import { CommanService } from '../../../_services/comman.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-ipd',
  standalone: true,
  imports: [
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    HighlightDirective,
    CardViewComponent,
    DetailViewComponent,
    DialogModule,
    BadgeModule,
    InputNumberModule,
    FontAwesomeModule,
    ToastModule,
    // SelectModule,
    RadioButtonModule,
    ButtonModule,
    TooltipModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './ipd.component.html',
  styleUrl: './ipd.component.scss',
})
export class IpdComponent {
  @ViewChild('dt_cols')
  dt_cols!: Table;
  searchType: string = '';

  TableName: string = 'INDIAN_PESTICIDE_DATABASE_MONGO';
  TemplateName: string = 'TEMPLATE_INDIAN_PESTICIDE_DATABASE_MONGO';
  pageTitile = 'INDIAN PESTICIDE DATABASE';
  appNamePrivelege = 'ipd-mongo-db';
  filterForm!: FormGroup;
  filterForm_normal!: FormGroup;
  filterForm_advanced!: FormGroup;
  filterForm_dynamic!: FormGroup;
  filterForm_combination!: FormGroup;
  form_RaiseQuery!: FormGroup;
  columns: any[] = [];
  scrollHeight = '250px';
  productDetailView: boolean = false;
  secondaryTableDetails: any;
  secondaryTableDownloadDetails: any;
  imageBaseUrls: any = {};

  backToListQuery: string = '';
  backToList: any = { search: false };
  secondaryTableFilterApplied = false;
  filterAndCond: any = [];
  filterProjObj: any = {};
  user_data: any;
  //Table Variables
  rows: any = 50;
  totalRecords!: number;
  loading_table!: boolean;
  products_current_datasource: any[] = [];
  cols: any[] = [];
  current_pagenumber: number = 1;
  IsShowFullPageData: boolean = false;
  IsNoRecordsFound: boolean = false;
  IsQueryErrorFound: boolean = false;
  IsFilterAplied: boolean = false;
  globalfilterFields: string[] = [];
  currentFilterCondition: any[] = [];
  currentSortBy: string = '';
  rptDataForExcel: any[] = [];
  tablefilter: any = {};
  primaryTablefilter: any = {};
  secondaryTablefilter: any = {};

  criteria: any[] = [];
  columnFilters: any = {};

  keyword: string = '';
  isShowTable: boolean = false;
  compound_count: number = 0;
  casrn_count: number = 0;
  company_count: number = 0;
  category_count: number = 0;
  country_count: number = 0;
  activeing_count: number = 0;
  first: any = 0;
  @ViewChild('dt') dataTable!: Table;
  isLastPage_var: boolean = false;
  isFirstPage_var: boolean = false;

  isListView: boolean = false;

  isShowFieldSetting: boolean = false;
  privilege_json!: user_privilege;
  pageLimitInPrivilegeJson: number = 0;
  pageLimitInDatabaseLimit: number = 0;
  constructor(
    private tableService: TableService,
    private route: ActivatedRoute,
    private router: Router,
    private commanService: CommanService,
    private datasearch: DatasearchService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private exportdataService: ExportDataService,
    // private primengConfig: PrimeNGConfig,
    private _constant: ConstantService,
    private cd: ChangeDetectorRef,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private confirmationService: ConfirmationService,
    private globalService: GlobalService,
    private authentication: AuthenticationService
  ) {
    // this.setIpandLocation();
  }
  current_GBRN: any = 0;
  acesss_key: any;
  msgs = [];
  carouselImgs: any = [
    { imgname: '1.jpg' },
    // {imgname:"2.jpg"},
    // {imgname:"3.jpg"},
    // {imgname:"4.jpg"}
  ];
  postdata: companydirectory_model = {
    mode: 'GET_AUTO_SUGGEST',
  };
  userid: number = 0;
  results!: string[];
  //  privilege_json!: user_privilege;
  //  Search condition object
  searchCondition = {};
  dateValue = {};
  oldSearchQueryGrid = '';
  querySuggestions: any = [
    { search_value: 'AND', columnName: 'AND', label: 'Operator' },
    { search_value: 'OR', columnName: 'OR', label: 'Operator' },
    { search_value: 'NOT', columnName: 'NOT', label: 'Operator' },
    {
      search_value: 'EQUAL TO',
      columnName: 'EQUAL TO',
      label: 'Date Operator',
    },
    {
      search_value: 'NOT EQUAL TO',
      columnName: 'NOT EQUAL TO',
      label: 'Date Operator',
    },
    { search_value: 'BETWEEN', columnName: 'BETWEEN', label: 'Date Operator' },
    {
      search_value: 'NOT BETWEEN',
      columnName: 'NOT BETWEEN',
      label: 'Date Operator',
    },
    { search_value: '(term)', columnName: '(term)', label: 'Field Text' },
    {
      search_value: '(term1 AND term2)',
      columnName: '(term1 AND term2)',
      label: 'Field Text',
    },
    {
      search_value: '(term1 OR term2)',
      columnName: '(term1 OR term2)',
      label: 'Field Text',
    },
    {
      search_value: '(dd-mm-yyyy TO *)',
      columnName: '(dd-mm-yyyy TO *)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
  ];

  ngOnInit(): void {
    this.commanService.productInformationData.subscribe((res: any) => {
      const rawQuery = res.searchQueryGrid || '';
      this.searchQueryGrid = this.parseSearchQuery(rawQuery); // <-- returns a string
      // console.log('search query grid in IPD : ', this.searchQueryGrid);
    });
    this.filterForm = this.fb.group({
      textautocomplete: [''],
      ddlfieldname: [''],
    });

    this.commanService.currentgbrn.subscribe((gbrn_res: any) => {
      if (gbrn_res) {
        this.current_GBRN = gbrn_res;
        // console.log('gbrn received from service', this.current_GBRN);

        // Delay patching slightly to ensure form is initialized properly
        setTimeout(() => {
          if (this.filterForm && this.filterForm.controls) {
            this.filterForm.controls['textautocomplete'].setValue(
              this.current_GBRN
            );
            this.filterForm.controls['ddlfieldname'].setValue('gbrn');
            // Perform search after patching
            this.SearchData(this.current_pagenumber, this.rows);
          } else {
            console.error('filterForm or its controls are not initialized.');
          }
        });
      } else {
        console.warn('No GBRN received from service.');
      }
    });
    this.commanService.getUserPrivilege().subscribe((priv) => {
      this.privilege_json = priv;
    });

    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
    });

    this.tableService.getSearchType().subscribe((data) => {
      this.searchType = data;
      this.updatePrivilege = true;
    });
    this.tableService.getColumns().subscribe((data) => {
      this.columns = data;
    });
    this.tableService.getProductDetailView().subscribe((data) => {
      this.productDetailView = data;
    });
    this.tableService.getAppNamePrivelege().subscribe((data) => {
      this.appNamePrivelege = data;
    });
    this.tableService.getTableStateWithDataSearch().subscribe((data) => {
      if (data.searchData) {
        this.rows = data.rows;
        this.current_pagenumber = data.pageNumber;
        this.setPageNumber();
      }
    });
    this.tableService.getFormData().subscribe((data) => {
      this.filterForm = data;
      this.newSearch();
      switch (this.searchType) {
        case 'Simple':
          this.filterForm_normal = data;
          break;
        case 'Advance':
          this.filterForm_advanced = data;
          break;
        case 'Dynamic':
          this.filterForm_dynamic = data;
          break;
      }
      this.Search();
    });
    this.loadColumnDetails();
    this.tableService.getShowTable().subscribe((data) => {
      this.isShowTable = data;
    });
    // this.getUserPrivilege();
    // this.loadTableConfig();

    // this.getSecondaryTables();
    // this.getImagesBasePath();

    // this.detailViewTemplate();
    this.tableService.getImagesBaseUrl().subscribe((data) => {
      this.imageBaseUrls = data;
    });
    this.initializeForm();

    // This method get page limit data for XIM 1.0
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error success false');
          }
        },
        (error: any) => {
          console.log('Error :', error);
        }
      );

    // If goBackToResult is true then called backToResult()
    this.globalService.backToResult.subscribe((res) => {
      if (res) {
        this.backToResult();
      }
    });
  }
  // async getUserPrivilege(): Promise<void> {

  //   this.authentication.getCurrentUserValue().subscribe((val:any) => {

  //     this.user_data = val;

  //     this.authentication
  //       .getUserPrivilege({
  //         mode: 'GET_USER_PRIVILEGE',
  //         userid: val.userid,
  //         app_json_name: 'mrl',
  //         application_name: 'MRL Discovery-suite-platform',
  //       })
  //       .subscribe({
  //         next: async (res: any) => {

  //           // Process privilege_json
  //           this.privilege_json = this._constant.getAppprivilege(
  //             res.privilege_json,
  //             'mrl',
  //             val.userid
  //           );

  //           // Send privilege_json to the service
  //           this.commanService.currentPrivilege_mrl.next(this.privilege_json);

  //         },
  //         error: (err) => {
  //           console.error('Error fetching privilege JSON:', err);
  //         },
  //       });
  //   });
  // }
  newSearch() {
    this.filterAndCond = [];
    this.filterProjObj = {};
    this.secondaryTableFilterApplied = false;
    this.primaryTablefilter = {};
    this.secondaryTablefilter = {};
    this.loading_table = true;
    this.current_pagenumber = 1;
    this.tablefilter = {};
    this.tableService.sendTableState({
      pageNumber: this.current_pagenumber,
      rows: this.rows,
    });
  }

  text!: string;
  operators: any = [
    { name: 'AND', value: 'AND' },
    { name: 'OR', value: 'OR' },
    { name: 'NOT', value: 'NOT' },
  ];
  patentTypes: any[] = [];

  TableRowsCounts: number[] = [50, 100, 150, 200];
  Default_DownloadRec_Limit: number = 500;

  search_filters!: search_filter;
  application_query!: string;
  user_ip!: string;
  address!: string;
  is_show_Search_Priv_popup!: boolean;
  is_show_Download_Priv_popup!: boolean;
  is_show_Total_Search_Exceed_popup!: boolean;
  is_show_Total_Download_Exceed_popup!: boolean;
  is_show_Daily_Search_Exceed_popup!: boolean;
  is_show_Daily_Download_Exceed_popup!: boolean;
  isShowRaiseQuery: boolean = false;
  secondaryTableList = [];

  initializeForm() {
    //Raise Query form
    this.form_RaiseQuery = this.fb.group({
      txtResponseEmail: ['', Validators.required],
      txtQuery: ['', Validators.required],
    });
  }

  loadTableConfig() {
    let postdata = {
      tablename: this.TableName,
    };
    this.datasearch.GetTemplateTableDtls(postdata).subscribe({
      next: (res) => {
        let data = res;
        this.Default_DownloadRec_Limit = data.Default_DownloadRec_Limit;
        this.TableRowsCounts.indexOf(data.Default_Grid_RowsCount) < 0
          ? this.TableRowsCounts.push(data.Default_Grid_RowsCount)
          : '';
        this.TableRowsCounts.sort((a, b) => {
          return a - b;
        });
        this.tableService.sendTableRowsCounts(this.TableRowsCounts);
        this.rows = data.Default_Grid_RowsCount;
        this.tableService.sendSearchOptions(data.Search_Options);
        this.tableService.sendDisplayPopup(data.ShowPopupbox);
        this.tableService.sendTableState({
          pageNumber: this.current_pagenumber,
          rows: this.rows,
        });
      },
      error(err) {
        console.log(err);
      },
      complete() {},
    });
  }

  selectedSearchOption: any = {
    name: 'Simple Search',
    value: 'SIMPLE',
    icon: 'bx-search',
  };

  filteredProducts: any[] = [];
  filteProducts(event: any) {
    let query = event.query;
    let searchCondition: any[] = [];
    let searchWordArr = query.split(/[^\w\s]/gi);
    searchWordArr.forEach((text: any) => {
      searchCondition.push({ product: { $regex: text, $options: 'i' } });
    });
    let postdata = {
      mode: 'GET_PRODUCTS',
      searchCondition: searchCondition,
      search_keyword: query,
      pagenumber: 1,
      rowscount: 30,
    };
    this.datasearch
      .quik_patent_combination_dropdown(postdata)
      .subscribe((res) => {
        let proddatatemp: any[] = res;
        this.filteredProducts = proddatatemp;
      });
  }

  getFieldType(fieldname: any) {
    return this.columns.find((item) => item.tableColumnName == fieldname)
      ?.fieldDataType;
  }

  IsSuggestedItemClick: boolean = false;
  SuggestedDbColumn: string = '';
  autoSearchSelect(searchItem: any) {
    this.IsSuggestedItemClick = true;
    this.SuggestedDbColumn = searchItem.columnname;
    this.filterForm_normal.controls['textautocomplete'].setValue(
      searchItem.search_value
    );
    this.Search();
  }

  // OpenProduct(data: any) {
  //   this._constant.prodData = data;
  //   let url = this.router.serializeUrl(
  //     this.router.createUrlTree(['/product_description'])
  //   );
  //   this.router.navigateByUrl(url, { state: data });
  //   //this.router.navigate([],{state:data}).then(result => {  window.open(url, '_blank'); });
  // }

  staticSuggestion(columnname: any, search_value: any) {
    switch (columnname) {
      case 'keyword':
        this.IsSuggestedItemClick = false;
        this.SuggestedDbColumn = '';
        this.filterForm_normal.controls['textautocomplete'].setValue(
          search_value
        );
        this.Search();
        break;
      default:
        let searchItem = { columnname: columnname, search_value: search_value };
        this.autoSearchSelect(searchItem);
        break;
    }
  }

  //#endregion
  //#region Adavnaced Search
  get advfilters(): FormArray {
    return this.filterForm_advanced.controls['advfilters'] as FormArray;
  }

  addFilter() {
    const advfilterForm = this.fb.group({
      ddloprator: new FormControl('AND', [Validators.required]),
      ddlfieldnameadv: new FormControl('', [Validators.required]),
      txtfiltervalue: new FormControl('', [Validators.required]),
    });
    this.advfilters.push(advfilterForm);
  }

  deleteFilter(advfilterIndex: number) {
    this.advfilters.removeAt(advfilterIndex);
  }
  //#endregion

  //#region Combination Search
  // searchCombination() {
  //   let txtcombination_1 =
  //     this.filterForm_combination.controls['txtcombination_1'].value;
  //   let txtcombination_2 =
  //     this.filterForm_combination.controls['txtcombination_2'].value;
  //   let txtcombination_3 =
  //     this.filterForm_combination.controls['txtcombination_3'].value;
  //   let txtcombination_4 =
  //     this.filterForm_combination.controls['txtcombination_4'].value;
  //   let txtcombination_5 =
  //     this.filterForm_combination.controls['txtcombination_5'].value;

  //   txtcombination_1 =
  //     txtcombination_1 !== '' && typeof txtcombination_1 != 'string'
  //       ? this.fultextEscape(txtcombination_1.product_name.trim())
  //       : txtcombination_1.trim();
  //   txtcombination_2 =
  //     txtcombination_2 !== '' && typeof txtcombination_2 != 'string'
  //       ? this.fultextEscape(txtcombination_2.product_name.trim())
  //       : txtcombination_2.trim();
  //   txtcombination_3 =
  //     txtcombination_3 !== '' && typeof txtcombination_3 != 'string'
  //       ? this.fultextEscape(txtcombination_3.product_name.trim())
  //       : txtcombination_3.trim();
  //   txtcombination_4 =
  //     txtcombination_4 !== '' && typeof txtcombination_4 != 'string'
  //       ? this.fultextEscape(txtcombination_4.product_name.trim())
  //       : txtcombination_4.trim();
  //   txtcombination_5 =
  //     txtcombination_5 !== '' && typeof txtcombination_5 != 'string'
  //       ? this.fultextEscape(txtcombination_5.product_name.trim())
  //       : txtcombination_5.trim();

  //   if (
  //     txtcombination_1 == '' &&
  //     txtcombination_2 == '' &&
  //     txtcombination_3 == '' &&
  //     txtcombination_4 == '' &&
  //     txtcombination_5 == ''
  //   ) {
  //     this.toastr.warning('Please fill any one combination field to search!');
  //   } else {
  //     this.Search();
  //   }
  // }
  //#endregion

  //#region  Table Related

  // Search Query
  isQueryOptionSelected: boolean = false;
  searchQueryGrid: string = '';
  regex_query =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  search_regex_query =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>(?:[^(]+|\([^)]*\))*)\)/g;
  regex_query1 =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  regex_query2 = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+)/gi;
  isValidQueryCondition: boolean = true;
  lastSearchQuery!: string;
  searchedWords: string[] = [];

  searchQuery() {
    this.isQueryOptionSelected = true;
    this.IsQueryErrorFound = false;
    //replace more than one space
    this.searchQueryGrid = this.searchQueryGrid.replace(/\s{2,}/gm, '');
    this.lastSearchQuery = JSON.stringify(this.searchQueryGrid);
    this.SearchData(this.current_pagenumber, this.rows);
  }

  // new validate query variables
  dropdownSuggestions1: any = [];
  isShowQueryBox1: boolean = false;
  operatorSelected1: string = '';
  fieldSelected1: string = '';
  additionalOperator1: string = '';
  typedQuery1: string[] = [];
  matchText1: string = '';

  validateQuery1(event: any) {
    let queryvalue = event.target.value;
    queryvalue = queryvalue.trim();

    //replace more than one space
    queryvalue = queryvalue.replace(/\s{2,}/gm, '');
    this.searchQueryGrid = queryvalue;

    let matches_conditions = [];
    let match_query: any[] = [];

    [...queryvalue.matchAll(this.search_regex_query)].forEach((queryGroup) => {
      match_query.push(queryGroup[0]);
      matches_conditions.push(queryGroup.groups);
    });
    let matched_string = match_query.join('');
    if (this.searchQueryGrid) {
      this.isValidQueryCondition = queryvalue.length == matched_string.length;
    } else {
      this.isValidQueryCondition = false;
      return;
    }
    let endString = this.searchQueryGrid.slice(matched_string.length);
    let endCondArr: any = [];
    let match: any;
    while ((match = this.regex_query2.exec(endString)) !== null) {
      endCondArr.push({
        operator: match.groups.operator,
        columnname: match.groups.columnname,
      });
    }

    if (
      this.searchQueryGrid.lastIndexOf(')') >
        this.searchQueryGrid.lastIndexOf('(') &&
      this.searchQueryGrid.lastIndexOf('(') >
        this.searchQueryGrid.lastIndexOf(':')
    ) {
      if (endCondArr.length === 0) {
        this.operatorSelected1 = 'no operator';
        this.isShowQueryBox1 = true;
        this.matchText1 = '';
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return item.label === 'Operator';
          }
        );
      } else if (!endCondArr[0].operator) {
        this.matchText1 = endCondArr[0].columnname;
        if (endCondArr[0].columnname.length > 3) {
          this.isShowQueryBox1 = true;
          this.operatorSelected1 = 'wrong operator';
          this.dropdownSuggestions1 = [];
        } else if (endCondArr[0].columnname) {
          this.isShowQueryBox1 = true;
          if (
            endCondArr[0].columnname.toUpperCase() === 'AND' ||
            endCondArr[0].columnname.toUpperCase() === 'OR' ||
            endCondArr[0].columnname.toUpperCase() === 'NOT'
          ) {
            this.operatorSelected1 = 'operator';
            this.searchQueryGrid = this.searchQueryGrid.slice(
              0,
              this.searchQueryGrid.lastIndexOf(')') + 1
            );
            this.searchQueryGrid += ' ' + this.matchText1.toUpperCase() + ' ';
            this.dropdownSuggestions1 = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Field';
              }
            );
          } else {
            this.isShowQueryBox1 = true;
            this.dropdownSuggestions1 = this.querySuggestions.filter(
              (item: any) => {
                return this.matchText1
                  ? item.label === 'Operator' &&
                      item.columnName
                        .toLowerCase()
                        .lastIndexOf(this.matchText1.toLowerCase()) >= 0
                  : item.label === 'Operator';
              }
            );
            this.operatorSelected1 =
              this.dropdownSuggestions1.length > 0
                ? 'no operator'
                : 'wrong operator';
          }
        }
      } else if (endCondArr[0].operator) {
        this.isShowQueryBox1 = true;
        this.matchText1 = endCondArr[0].columnname;
        this.operatorSelected1 = 'operator';
        this.searchQueryGrid = this.searchQueryGrid.slice(
          0,
          this.searchQueryGrid.lastIndexOf(')') + 1
        );
        this.searchQueryGrid +=
          ' ' +
          endCondArr[0].operator.toUpperCase() +
          ' ' +
          endCondArr[0].columnname;
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return this.matchText1
              ? item.label === 'Field' &&
                  item.columnName
                    .toLowerCase()
                    .lastIndexOf(this.matchText1.toLowerCase()) >= 0
              : item.label === 'Field';
          }
        );
        this.fieldSelected1 =
          this.dropdownSuggestions1.length > 0 ? 'no field' : 'wrong field';
      }
    } else if (
      this.searchQueryGrid.lastIndexOf(')') >
        this.searchQueryGrid.lastIndexOf('(') &&
      this.searchQueryGrid.lastIndexOf(':') >
        this.searchQueryGrid.lastIndexOf(')')
    ) {
      if (endCondArr.length === 0) {
        this.operatorSelected1 = 'select operator';
        this.fieldSelected1 = 'select field';
        this.isShowQueryBox1 = true;
        this.dropdownSuggestions1 = [];
        this.matchText1 = '';
      } else if (!endCondArr[0].operator) {
        if (endCondArr[0].columnname === ' ') {
          this.operatorSelected1 = 'select operator';
          this.fieldSelected1 = 'select field';
          this.isShowQueryBox1 = true;
          this.dropdownSuggestions1 = [];
          this.matchText1 = '';
        } else if (endCondArr[0].columnname.length > 3) {
          this.isShowQueryBox1 = true;
          let typedValue = this.querySuggestions.filter((item: any) => {
            return (
              item.label === 'Field' &&
              item.columnName.toLowerCase() ===
                endCondArr[0].columnname.toLowerCase()
            );
          });
          if (typedValue.length > 0) {
            this.operatorSelected1 = 'select operator';
            this.fieldSelected1 = 'field';
            this.searchQueryGrid = this.searchQueryGrid.slice(
              0,
              this.searchQueryGrid.lastIndexOf(')') + 1
            );
            this.searchQueryGrid += ' ' + typedValue[0].columnName + ':';
          } else {
            this.operatorSelected1 = 'select operator';
            this.fieldSelected1 = 'select field';
          }
          this.dropdownSuggestions1 = [];
        } else if (endCondArr[0].columnname) {
          this.isShowQueryBox1 = true;
          if (
            endCondArr[0].columnname.toUpperCase() === 'AND' ||
            endCondArr[0].columnname.toUpperCase() === 'OR' ||
            endCondArr[0].columnname.toUpperCase() === 'NOT'
          ) {
            this.operatorSelected1 = 'operator';
            this.fieldSelected1 = 'wrong field';
            this.searchQueryGrid = this.searchQueryGrid.slice(
              0,
              this.searchQueryGrid.lastIndexOf(')') + 1
            );
            this.searchQueryGrid +=
              ' ' + endCondArr[0].columnname.toUpperCase() + ' :';
            this.dropdownSuggestions1 = [];
          } else {
            this.operatorSelected1 = 'select operator';
            this.fieldSelected1 = 'select field';
            this.dropdownSuggestions1 = [];
          }
        }
      } else if (endCondArr[0].operator) {
        this.isShowQueryBox1 = true;
        this.matchText1 = '';
        this.operatorSelected1 = 'operator';
        this.searchQueryGrid = this.searchQueryGrid.slice(
          0,
          this.searchQueryGrid.lastIndexOf(')') + 1
        );
        let typedValue = this.querySuggestions.filter((item: any) => {
          return (
            item.label === 'Field' &&
            item.columnName.toLowerCase() ===
              endCondArr[0].columnname.toLowerCase()
          );
        });
        if (typedValue.length > 0) {
          this.fieldSelected1 = 'field';
          this.searchQueryGrid +=
            ' ' +
            endCondArr[0].operator.toUpperCase() +
            ' ' +
            typedValue[0].columnName +
            ':(';
          if (typedValue[0].columnName === 'PATENT TYPE') {
            this.dropdownSuggestions1 = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Patent Type';
              }
            );
          } else {
            this.dropdownSuggestions1 = this.querySuggestions.filter(
              (item: any) => {
                return typedValue[0].fieldDataType === 'text'
                  ? item.label === 'Field Text'
                  : item.label === 'Field Date';
              }
            );
          }
        } else {
          this.fieldSelected1 = 'wrong field';
          this.searchQueryGrid +=
            ' ' +
            endCondArr[0].operator.toUpperCase() +
            ' ' +
            endCondArr[0].columnname +
            ':';
          this.dropdownSuggestions1 = [];
        }
      }
    } else if (
      this.searchQueryGrid.lastIndexOf(')') > 0 &&
      this.searchQueryGrid.lastIndexOf(')') <
        this.searchQueryGrid.lastIndexOf(':') &&
      this.searchQueryGrid.lastIndexOf(':') <
        this.searchQueryGrid.lastIndexOf('(')
    ) {
      console.log(endCondArr);
      if (endCondArr.length === 2) {
        this.matchText1 = endCondArr[1].columnname;
      } else {
        this.matchText1 = '';
      }
      if (endCondArr[0].columnname === 'PATENT TYPE') {
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return this.matchText1
              ? item.label === 'Patent Type' &&
                  item.columnName
                    .toLowerCase()
                    .lastIndexOf(this.matchText1.toLowerCase()) >= 0
              : item.label === 'Patent Type';
          }
        );
        this.isShowQueryBox1 = true;
        this.operatorSelected1 = 'operator';
        this.fieldSelected1 = 'field';
      } else {
      }
    } else {
      this.matchText1 = '';
      this.matchText1 = endCondArr[0].columnname.trim();
      if (this.searchQueryGrid.lastIndexOf(':') < 0) {
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return this.matchText1
              ? item.label === 'Field' &&
                  item.columnName
                    .toLowerCase()
                    .lastIndexOf(this.matchText1.toLowerCase()) >= 0
              : item.label === 'Field';
          }
        );
        this.isShowQueryBox1 = true;
        if (!this.dropdownSuggestions1.length) {
          this.fieldSelected1 = 'wrong field';
        } else {
          this.fieldSelected1 = '';
        }
      } else {
        this.fieldSelected1 = '';
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return this.matchText1
              ? item.label === 'Field' &&
                  item.columnName
                    .toLowerCase()
                    .lastIndexOf(this.matchText1.toLowerCase()) >= 0
              : item.label === 'Field';
          }
        );
        if (this.dropdownSuggestions1.length) {
          this.searchQueryGrid = this.dropdownSuggestions1[0].columnName + ':(';
          this.matchText1 =
            endCondArr.length === 1 ? '' : endCondArr[1].columnname;
          if (this.dropdownSuggestions1[0].columnName === 'PATENT TYPE') {
            this.dropdownSuggestions1 = this.querySuggestions.filter(
              (item: any) => {
                return this.matchText1
                  ? item.label === 'Patent Type' &&
                      item.columnName
                        .toLowerCase()
                        .lastIndexOf(this.matchText1.toLowerCase()) >= 0
                  : item.label === 'Patent Type';
              }
            );
            this.isShowQueryBox1 = true;
            this.operatorSelected1 = 'operator';
            this.fieldSelected1 = 'field';
          } else if (this.dropdownSuggestions1[0].fieldDataType === 'date') {
            this.dropdownSuggestions1 = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Field Date';
              }
            );
          } else {
            this.dropdownSuggestions1 = this.querySuggestions.filter(
              (item: any) => {
                return item.label === 'Field Text';
              }
            );
          }
        } else {
          this.fieldSelected1 = 'wrong field';
        }
      }
    }
  }

  autoQuerySelect1(item: any) {
    if (this.searchQueryGrid.lastIndexOf(':') < 0) {
      this.searchQueryGrid = item.columnName + ':(';
      this.matchText1 = '';
      if (this.dropdownSuggestions1[0].columnName === 'PATENT TYPE') {
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return this.matchText1
              ? item.label === 'Patent Type' &&
                  item.columnName
                    .toLowerCase()
                    .lastIndexOf(this.matchText1.toLowerCase()) >= 0
              : item.label === 'Patent Type';
          }
        );
        this.isShowQueryBox1 = true;
        this.operatorSelected1 = 'operator';
        this.fieldSelected1 = 'field';
      } else if (this.dropdownSuggestions1[0].fieldDataType === 'date') {
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return item.label === 'Field Date';
          }
        );
      } else {
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return item.label === 'Field Text';
          }
        );
      }
    } else {
      if (item.label === 'Operator') {
        this.searchQueryGrid = this.searchQueryGrid.slice(
          0,
          this.searchQueryGrid.lastIndexOf(')') + 1
        );
        this.searchQueryGrid += ' ' + item.columnName + ' ';
        this.dropdownSuggestions1 = this.querySuggestions.filter(
          (item: any) => {
            return item.label === 'Field';
          }
        );
        this.isShowQueryBox1 = true;
        this.matchText1 = '';
        this.operatorSelected1 = 'operator';
        this.fieldSelected1 = 'no field';
      } else if (item.label === 'Field') {
        this.searchQueryGrid = this.searchQueryGrid.trim();
        // this.searchQueryGrid = this.searchQueryGrid.slice(0, this.searchQueryGrid.lastIndexOf(' '));
        let endString = this.searchQueryGrid.slice(
          this.searchQueryGrid.lastIndexOf(')')
        );
        let endCondArr: any = [];
        let match: any;
        while ((match = this.regex_query2.exec(endString)) !== null) {
          endCondArr.push({
            operator: match.groups.operator,
            columnname: match.groups.columnname,
          });
        }
        console.log(endCondArr);
        this.searchQueryGrid = this.searchQueryGrid
          .slice(0, this.searchQueryGrid.lastIndexOf(')') + 1)
          .trim();
        this.searchQueryGrid += endCondArr[0].operator
          ? ' ' + endCondArr[0].operator + ' ' + item.columnName + ':('
          : ' ' + endCondArr[0].columnname + ' ' + item.columnName + ':(';
        this.dropdownSuggestions1 = this.querySuggestions.filter((val: any) => {
          return item.fieldDataType === 'text'
            ? val.label === 'Field Text'
            : val.label === 'Field Date';
        });
        this.isShowQueryBox1 = true;
        this.matchText1 = '';
        this.operatorSelected1 = 'operator';
        this.fieldSelected1 = 'field';
      }
    }
    document.getElementById('inputSearchQuery1')!.focus();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.isShowQueryBox1 = false;
    }
  }

  handleDocumentClick(event: MouseEvent) {
    if (this.inputQuery && this.inputQuery.nativeElement) {
      const inputElement = this.inputQuery.nativeElement;

      if (inputElement.contains(event.target)) {
        // Clicked inside the input box
        return;
      }
    }
    this.isShowQueryBox1 = false;
  }

  @ViewChild('inputQuery1') inputQuery!: ElementRef;
  @ViewChild('queryBox') queryBox!: ElementRef;
  @ViewChild('document') document!: ElementRef;

  validateQuery(event: any) {
    let queryvalue = event.target.value;
    queryvalue = queryvalue.trim();

    //replace more than one space
    queryvalue = queryvalue.replace(/\s{2,}/gm, '');
    this.searchQueryGrid = queryvalue;

    let andorregex = /(AND|OR)(?!.*(AND|OR))$/gm;
    if (andorregex.test(queryvalue)) {
      this.isValidQueryCondition = false;
      return;
    }

    let matches_conditions = queryvalue.match(this.regex_query);
    let matched_string = matches_conditions.join('');
    let conditionlength = queryvalue.length;
    this.isValidQueryCondition = conditionlength == matched_string.length;
  }

  next() {
    //this.first = this.first + this.rows + 1;
    this.setCurrentPage(this.current_pagenumber + 1);
  }
  prev() {
    //this.first = this.first + this.rows + 1;
    this.setCurrentPage(this.current_pagenumber - 1);
  }
  isLastPage() {
    this.isLastPage_var = this.products_current_datasource
      ? this.current_pagenumber == Math.ceil(this.totalRecords / this.rows)
      : true;
  }
  isFirstPage() {
    this.isFirstPage_var = this.products_current_datasource
      ? this.first === 0
      : true;
  }

  scrollLeft() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft -= 500) : '';
  }
  scrollRight() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft += 500) : '';
  }

  setCurrentPage(n: number) {
    let paging: any = {
      first: (n - 1) * (this.dataTable?.rows || 0),
      rows: this.dataTable?.rows || 0,
    };
    this.first = paging.first;
    this.dataTable.onPageChange(paging);
  }

  paginate(event: any) {
    //event.first: Index of first record being displayed
    //event.rows: Number of rows to display in new page
    //event.page: Index of the new page
    //event.pageCount: Total number of pages
    let pageIndex = event.first / event.rows + 1; // Index of the new page if event.page not defined.
  }

  listSortByfield!: string;
  listSortOrder: string = 'ASC';
  sortBydata() {
    if (this.listSortByfield) {
      this.currentSortBy = `${this.listSortByfield} ${this.listSortOrder}`;
      this.SearchData(this.current_pagenumber, this.rows);
    }
  }

  Search() {
    // if (this._constant.isLoggedIn == false) {
    //   this.tableService.sendShowAccessDialog(true);
    //   this.IsFilterAplied = false;
    //   return;
    // }
    if (this.checkUserSearchPrivillege() == false) {
      return;
    }

    // We update "isComeFromFilter" because it use in "no-record-component"
    this.globalService.isComeFromFilter.next(false);

    this.tableService.sendShowTable(false);
    // this.keyword=this.filterForm_normal.controls.textautocomplete.value.trim();
    this.IsQueryErrorFound = false;
    this.searchQueryGrid = '';
    this.SearchData(this.current_pagenumber, this.rows);
  }

  reset_advanced() {
    this.filterForm_advanced.reset();
    this.dynSelectedPatentType = '';
  }
  reset_combination() {
    this.filterForm_combination.reset();
    this.dynSelectedPatentType = '';
  }

  loadColumnDetails() {
    // this.busyService.busy();
    this.datasearch.table_column_config().subscribe(
      (res: any) => {
        // console.log('API Response:', res);
        if (res && res.data && res.data.results) {
          res.data.results.forEach((field: any) => {
            if (field.columnWidth && typeof field.columnWidth === 'string') {
              field.columnWidth = parseInt(field.columnWidth.replace('px', ''));
            }
          });
          this.cols = res.data.results;
          console.log(
            '--------------------------Processed Columns:',
            this.cols
          );

          this.tableService.sendCols(this.cols);
        } else {
          console.warn('Unexpected API response structure:', res);
          // this.toastr.warning('Column data format is not as expected.');
        }
      },
      (error: any) => {
        console.error('API Error Details:', error);
        // this.toastr.error(
        //   'Failed to load column details. Please check the API endpoint and network connection.'
        // );
      },
      () => {
        // this.busyService.idle();
      }
    );
  }

  saveColumnDetails() {
    let postdata = {
      mode: 'SAVE_COLUMNS_CONFIG',
      cols_data: this.cols,
      templateName: 'TEMPLATE_INDIAN_PESTICIDE_DATABASE_MONGO_MAIN',
      userid: this.userid,
    };

    this.busyService.busy();
    this.datasearch.save_table_column_config(postdata).subscribe(
      (res) => {
        // this.toastr.success('Field(s) Configuration Saved Successfully');
        this.busyService.idle();
      },
      (error) => {
        this.busyService.idle();
        // this.toastr.error('Something went wrong! Please try again. (4)');
      }
    );
  }

  // detailViewTemplate() {
  //   let postdata = {
  //     tableName: this.TableName,
  //   };
  //   this.datasearch.table_detail_view_template(postdata).subscribe(
  //     (res) => {
  //       this.tableService.sendDetailViewTemplate(res.data);
  //     },
  //     (error) => {
  //       console.log(error);
  //       // this.toastr.error('Something went wrong! Please try again. (5)');
  //     }
  //   );
  // }

  globalColFilter(event: any) {
    this.dt_cols.filterGlobal(event.target.value, 'contains');
  }

  filterVal(event: any, col: any) {
    // if(col.tableName === this.secondaryTableDetails.parentTable){
    //   this.primaryTablefilter[col.field] = {value: event.target.value, matchMode: ''};
    // }else{
    //   if(!this.secondaryTablefilter.hasOwnProperty(col.tableName)){
    //     this.secondaryTablefilter[col.tableName] = {};
    //   }
    //   this.secondaryTablefilter[col.tableName][col.field] = {value: event.target.value, matchMode: ''};
    // }
  }

  setPageNumber() {
    this.first = (this.current_pagenumber - 1) * this.rows;

    this.SearchData(this.current_pagenumber, this.rows);
  }

  updatePrivilege = false;

  // loadProducts(event: LazyLoadEvent) {
  //   this.updatePrivilege = false;
  //   this.filterAndCond = [];
  //   this.filterProjObj = {};
  //   this.secondaryTableFilterApplied = false;
  //   this.primaryTablefilter = {};
  //   this.secondaryTablefilter = {};
  //   this.loading_table = true;

  //   this.current_pagenumber = (event.first ?? 0) / (event.rows ?? 10) + 1;
  //   this.rows = event.rows ?? 10;

  //   this.tableService.sendTableState({
  //     pageNumber: this.current_pagenumber,
  //     rows: this.rows,
  //   });
  //   this.tablefilter = event.filters;
  //   Object.keys(this.primaryTablefilter).forEach(
  //     (val) =>
  //       (this.primaryTablefilter[val].matchMode =
  //         this.tablefilter[val].matchMode)
  //   );
  //   Object.keys(this.secondaryTablefilter).forEach((val) => {
  //     Object.keys(this.secondaryTablefilter[val]).forEach(
  //       (field) =>
  //         (this.secondaryTablefilter[val][field].matchMode =
  //           this.tablefilter[field].matchMode)
  //     );
  //   });

  //   this.cols.forEach((col) => {
  //     if (this.tablefilter.hasOwnProperty(col.field)) {
  //       if (col.tableName === this.secondaryTableDetails.parentTable) {
  //         this.tablefilter[col.field].value
  //           ? (this.primaryTablefilter[col.field] = this.tablefilter[col.field])
  //           : '';
  //       } else {
  //         if (!this.secondaryTablefilter.hasOwnProperty(col.tableName)) {
  //           this.secondaryTablefilter[col.tableName] = {};
  //         }
  //         if (this.tablefilter[col.field].value) {
  //           this.secondaryTableFilterApplied = true;
  //           this.secondaryTablefilter[col.tableName][col.field] =
  //             this.tablefilter[col.field];
  //         }
  //       }
  //     }
  //   });
  //   this.first = event.first;
  //   //SORT BY CONDITION
  //   if (event.sortField && this.isListView == false) {
  //     this.currentSortBy = `${event.sortField} ${
  //       event.sortOrder == 1 ? 'ASC' : 'DESC'
  //     }`;
  //   } else if (this.isListView == true && this.listSortByfield) {
  //     this.currentSortBy = `${this.listSortByfield} ${this.listSortOrder}`;
  //   } else {
  //     this.currentSortBy = '';
  //   }

  //   setTimeout(() => {
  //     !this.secondaryTableFilterApplied
  //       ? this.SearchData(this.current_pagenumber, event.rows ?? 10)
  //       : this.SearchSecondaryData(this.current_pagenumber, event.rows ?? 10);
  //   }, 1000);
  // }

  loadProducts(event: any) {
    // Reset states and filters
    this.updatePrivilege = false;
    this.filterAndCond = [];
    this.filterProjObj = {};
    this.primaryTablefilter = {};
    this.loading_table = true;

    this.globalService.isComeFromFilter.next(true);

    this.current_pagenumber = Math.max(
      1,
      (event.first ?? 0) / (event.rows ?? 10) + 1
    );

    // Check for page limit
    this.handlePageLimit();
    if (this.pageLimitInPrivilegeJson) {
      if (this.current_pagenumber > this.pageLimitInPrivilegeJson) {
        this.messageService.add({
          severity: 'error',
          summary: 'Page Limit Exceeded',
          detail: `You only see ${this.pageLimitInPrivilegeJson} pages`,
        });
        this.loading_table = false;
        return;
      }
    } else if (this.pageLimitInDatabaseLimit) {
      if (this.current_pagenumber > this.pageLimitInDatabaseLimit) {
        this.messageService.add({
          severity: 'error',
          summary: 'Page Limit Exceeded',
          detail: `You only see ${this.pageLimitInDatabaseLimit} pages`,
        });
        this.loading_table = false;
        return;
      }
    }

    this.rows = event.rows ?? 10;
    this.tableService.sendTableState({
      pageNumber: this.current_pagenumber,
      rows: this.rows,
    });
    this.tablefilter = event.filters || {};

    Object.keys(this.tablefilter).forEach((field) => {
      const f = this.tablefilter[field];

      // PrimeNG filter format: [{value, matchMode}] or {value,matchMode}
      if (Array.isArray(f)) {
        this.primaryTablefilter[field] = {
          value: f[0]?.value ?? '',
          matchMode: f[0]?.matchMode ?? 'contains',
        };
      } else {
        this.primaryTablefilter[field] = {
          value: f.value,
          matchMode: f.matchMode ?? 'contains',
        };
      }
    });

    console.log('Unified Table Filters:', this.primaryTablefilter);

    this.first = event.first;

    if (event.sortField && !this.isListView) {
      this.currentSortBy = `${event.sortField} ${
        event.sortOrder === 1 ? 'ASC' : 'DESC'
      }`;
    } else if (this.isListView && this.listSortByfield) {
      this.currentSortBy = `${this.listSortByfield} ${this.listSortOrder}`;
    } else {
      this.currentSortBy = '';
    }

    setTimeout(() => {
      this.SearchData(this.current_pagenumber, this.rows);
    });
  }

  validateForm() {
    switch (this.searchType) {
      case 'Simple':
        if (!this.filterForm.controls['textautocomplete'].value) {
          // this.toastr.warning('Please fill keyword to search!');
          return false;
        } else if (!this.filterForm.controls['ddlfieldname'].value) {
          // this.toastr.warning('Please select field to search!');
          return false;
        } else {
          return true;
        }
      case 'Advance':
        let selectedAdvFilter: boolean = false;
        for (let i = 0; i < this.filterForm.value.advfilters.length; i++) {
          if (
            this.filterForm.value.advfilters[i].ddlfieldnameadv !== '' &&
            this.filterForm.value.advfilters[i].txtfiltervalue !== ''
          ) {
            selectedAdvFilter = true;
            break;
          }
        }
        if (selectedAdvFilter) {
          return true;
        } else {
          // this.toastr.warning(
          //   'Please fill any one filter condition to search!'
          // );
          return false;
        }
      case 'Dynamic':
        let selectedDynFilter: boolean = false;
        for (let i = 0; i < this.filterForm.value.dynfilters.length; i++) {
          if (this.filterForm.value.dynfilters[i].txtfiltervaluedyn) {
            selectedDynFilter = true;
            break;
          }
        }
        if (selectedDynFilter) {
          return true;
        } else {
          // this.toastr.warning('Please fill any one field condition to search!');
          return false;
        }
      default:
        return true;
    }
  }

  // async SearchSecondaryData(pagenumber: number, rowscount: number) {
  //   try {
  //     const secTableData = Array.isArray(this.secondaryTableDetails)
  //       ? this.secondaryTableDetails
  //       : [this.secondaryTableDetails];

  //     if (secTableData.length === 0) {
  //       console.warn('No GBRN secondary data found');
  //       this.SearchData(pagenumber, rowscount);
  //       return;
  //     }

  //     const gbrnValues = secTableData
  //       .map((item: any) => item.gbrn)
  //       .flat()
  //       .filter((val: any) => val);

  //     const cond = {
  //       gbrnArray: {
  //         $in: gbrnValues,
  //       },
  //     };

  //     this.filterProjObj = {
  //       gbrnArray: {
  //         $map: {
  //           input: { $split: ['$gbrn', ','] },
  //           as: 'value',
  //           in: { $trim: { input: '$$value' } },
  //         },
  //       },
  //     };

  //     this.filterAndCond = [cond];

  //     this.SearchData(pagenumber, rowscount);
  //   } catch (error: any) {
  //     console.error('Error in SearchSecondaryData:', error);
  //     // this.toastr.error(
  //     //   error?.error?.error || 'Error occurred while searching secondary data'
  //     // );
  //   }
  // }

  SearchData(pagenumber: number, rowscount: number) {
    if (!this.authentication.getLoginUser()) {
      console.log('User not logged in. Showing access dialog.');
      this.tableService.sendShowAccessDialog(true);
      this.IsFilterAplied = false;
      return;
    }

    if (!this.validateForm()) {
      return;
    }

    this.busyService.busy();

    this.currentFilterCondition = this.getFilterCondition();
    console.log('Current Filter Condition:', this.currentFilterCondition);

    if (this.currentFilterCondition.length == 0) {
      this.messageService.add({
        severity: 'error',
        sticky: false,
        summary: 'Filter detail(s) required',
        detail: 'Please apply above filter to searching data!',
      });
      return;
    }

    let filtercondition = this.getQuery(this.current_pagenumber, this.rows);

    this.globalService.searchQuery.next(this.searchQueryGrid);
    this.globalService.searchFilters.next(this.search_filters);

    let postdata = {
      search_type: this.searchType,
      criteria: this.currentFilterCondition || [],
      pagenumber: pagenumber,
      rowscount: rowscount,
      sortby: this.currentSortBy || '',
      filters: filtercondition,
      subFilters: {},

      activityObj: {
        userId: this.user_data.userid || '',
        userEmail:this.user_data.email || '',
        privilegeName: 'IPD_SEARCH',
        mode: 'search',
        query: this.searchQueryGrid || '',
        searchFilters: this.search_filters,
        userIp: this.user_ip || '',
        address: this.address || '',
      },
    };

    this.datasearch.table_data(postdata).subscribe(
      (res) => {
        let response: any = res.data.results;
        this.tableService.showResult.next(true);
        this.tableService.sendShowTable(true);
        this.tableService.sendSearchedWords(this.searchedWords);
        if (res?.status == 'error') {
          // this.toastr.error('Something went wrong..please try again! (6)');
          this.IsSuggestedItemClick = false;
          this.SuggestedDbColumn = '';
          this.busyService.idle();
          return;
        }
        response.forEach((item: any) => {
          if (item.gbrn && typeof item.gbrn !== 'string') {
            item.gbrn = item.gbrn.toString();
          }
        });
        this.products_current_datasource = response;
        this.scrollHeight =
          this.products_current_datasource.length < 6
            ? this.products_current_datasource.length * 100 + 150 + 'px'
            : '1285px';
        this.totalRecords = res.data?.totalCount;
        this.globalService.totalRecordsCount.next(this.totalRecords);
        this.secondaryTableDetails = response.flatMap(
          (item: any) => item.gbrn_products || []
        );
        this.tableService.sendSecondaryTableDetails(this.secondaryTableDetails);
        // const colsValue = this.tableService.cols.getValue();
        this.hideColumns();
        this.cols.forEach((field) => {
          if (typeof field.columnWidth === 'string') {
            field.columnWidth = parseInt(
              field.columnWidth.replace('px', ''),
              10
            );
          } else if (typeof field.columnWidth === 'number') {
          } else {
            field.columnWidth = 0;
          }
        });

        this.products_current_datasource.forEach((item) => {
          this.cols.forEach((x) => {
            if (x.fieldDataType == 'date') {
              if (item[x.field] == '0000-00-00') {
                item[x.field] = '';
              } else {
                try {
                  item[x.field] = this.datePipe.transform(
                    item[x.field],
                    'yyyy-MM-dd'
                  );
                } catch (e) {
                  console.log(e);
                }
              }
            }
          });
        });

        this.products_current_datasource.forEach((row, index) => {
          row.S_NO = (pagenumber - 1) * rowscount + index + 1;
        });

        this.tableService.sendProductCurrentDatasource(
          this.products_current_datasource
        );
        this.tableService.sendTotalRecords(this.totalRecords);
        this.tableService.sendDetailViewTemplate(response);
        // this.tableService.sendCols(this.cols);
        this.globalfilterFields = this.cols.map((item) => item.field);
        // console.log('Global Filter Fields:', this.globalfilterFields);
        if (this.totalRecords === 0) {
          this.IsNoRecordsFound = true;
          // this.toastr.info(
          //   'No record(s) found for current filter criteria. Please try again!'
          // );
        } else {
          this.backToListQuery = this.searchQueryGrid
            ? this.searchQueryGrid
            : this.backToListQuery;
          this.backToList.search = true;
          this.backToList.searchType = this.searchType;
          this.backToList.value = this.filterForm.value;
          this.IsNoRecordsFound = false;
          // this.toastr.info(
          //   '<span>Please use Right(&rarr;)/Left(&rarr;) arrow key button to scroll to view data!</span>',
          //   'Info!',
          //   { enableHtml: true, closeButton: true, timeOut: 10000 }
          // );
          // this.getSecondaryTablesData();
        }
        this.isFirstPage();
        this.isLastPage();
        this.loading_table = false;
        this.tableService.sendShowTable(true);
        this.IsSuggestedItemClick = false;
        this.SuggestedDbColumn = '';
        this.busyService.idle();
        this.cd.detectChanges();
      },
      (errorobj) => {
        console.log(errorobj);
        this.tableService.sendShowTable(true);
        this.tableService.showResult.next(true);
        this.IsQueryErrorFound =
          (errorobj.error?.message?.includes(
            'You have an error in your SQL syntax;'
          ) == true ||
            errorobj.error?.message?.includes('ER_BAD_FIELD_ERROR') == true) &&
          this.isQueryOptionSelected == true;
        if (this.IsQueryErrorFound == false) {
          // this.toastr.error('Something went wrong! Please try again.(7)');
        } else {
          // this.toastr.error(
          //   'Correct the query string (Check column name and conditions) and try again.'
          // );
        }

        this.loading_table = false;
        this.IsNoRecordsFound = true;
        this.IsSuggestedItemClick = false;
        this.SuggestedDbColumn = '';
        // this.busyService.idle();
      },
      () => {
        // this.busyService.idle();
      }
    );
  }

  getQuery(pageNumber: number, limit: number) {
    let filtersObj: any = {};

    // 1️⃣ PRIMARY TABLE FILTERS (normal PrimeNG column filters)
    if (
      this.primaryTablefilter &&
      Object.keys(this.primaryTablefilter).length > 0
    ) {
      const tableFilterConditions = this._constant.getTableFilterCondition(
        this.primaryTablefilter
      );

      tableFilterConditions.forEach((filter: any) => {
        Object.keys(filter).forEach((key) => {
          filtersObj[key] = filter[key];
        });
      });
    }

    // 2️⃣ ADDITIONAL MAIN FILTERS (from dropdown UI)
    if (this.filterAndCond && Array.isArray(this.filterAndCond)) {
      this.filterAndCond.forEach((cond: any) => {
        if (!cond || typeof cond !== 'object') return;

        Object.keys(cond).forEach((key) => {
          let val = cond[key];
          if (val == null || val === '') return;

          if (typeof val === 'object') {
            val = val.label || val.value || '';
          }
          filtersObj[key] = val;
        });
      });
    }

    // 3️⃣ NEW → SECONDARY TABLE FILTERS
    if (
      this.secondaryTablefilter &&
      Object.keys(this.secondaryTablefilter).length > 0
    ) {
      Object.keys(this.secondaryTablefilter).forEach((secKey) => {
        const secValue = this.secondaryTablefilter[secKey];

        if (!secValue || secValue.trim() === '') return;

        // MongoDB $elemMatch to search inside array objects
        filtersObj[`gbrn_products`] = {
          $elemMatch: {
            [secKey]: { $regex: secValue, $options: 'i' },
          },
        };
      });
    }

    console.log('Final Filters:', JSON.stringify(filtersObj));
    return [filtersObj];
  }

  onTableFilter(event: any) {
    console.log('Table filter applied:', event);

    // Store the filter data
    this.primaryTablefilter = event.filters || {};
    this.secondaryTablefilter = event.filter || {};
    this.columnFilters = event.filters || {};

    // Reset to first page when filter is applied
    this.current_pagenumber = 1;
    this.first = 0;

    // Call API with new filters
    this.SearchData(this.current_pagenumber, this.rows);
  }

  getFilterCondition(tablefilterdata: any = {}) {
    let searchConditionArr: any = {};
    this.search_filters = new search_filter();
    // Only Simple Search logic with fixed column 'gbrn'
    searchConditionArr = this.simpleFilter();
    this.application_query = searchConditionArr.toString();
    return searchConditionArr;
  }

  simpleFilter() {
    const gbrn = this.current_GBRN; // using the value you got from subscription
    console.log('gbrn : ', gbrn);

    // Inject GBRN into the form fields
    this.filterForm.controls['textautocomplete'].setValue(gbrn);
    this.filterForm.controls['ddlfieldname'].setValue('gbrn');

    const searchtext = gbrn;
    const columnName = 'gbrn';
    let searchWordArr = [];
    let searchCondition: any[] = [];
    // searchWordArr.push(searchtext.replace(/[^a-zA-Z0-9\s]/g, '\\$&'));
    // searchWordArr.push(searchtext.replace(/[^\w\s]+/gi, ''));
    // searchWordArr.push(searchtext.replace(/[^\w\s]+/gi, ' '));
    this.criteria = [
      {
        field: columnName,
        keyword: String(searchtext ?? ''),
      },
    ];
    searchCondition = this.criteria.map((c) => ({
      field: c.field,
      keyword: c.keyword,
    }));
    this.searchQueryGrid = `${columnName}:(${searchtext})`;
    let tablelevlfiltercondition = this._constant.getTableFilterCondition(
      this.primaryTablefilter
    );
    searchCondition = searchCondition.concat(tablelevlfiltercondition);
    // this.searchedWords.push(searchtext);
    this.search_filters.textColumn = [columnName];
    this.search_filters.textValue = [searchtext];
    this.search_filters.SeachType = 'Simple';
    return searchCondition;
  }

  // advanceFilter() {
  //   let advfilter_cnt = this.filterForm.value.advfilters.length;
  //   this.search_filters.SeachType = 'Advance';
  //   this.search_filters.textColumn = [];
  //   this.search_filters.textValue = [];
  //   let andArr = [];
  //   let orArr = [];
  //   let searchCondition = [];

  //   // ✅ Added: initialize criteria for payload
  //   this.criteria = [];

  //   for (let i = 0; i < advfilter_cnt; i++) {
  //     let columnname =
  //       this.filterForm_advanced.value.advfilters[i].ddlfieldnameadv;
  //     let columnvalue =
  //       this.filterForm_advanced.value.advfilters[i].txtfiltervalue;
  //     let operator = this.filterForm_advanced.value.advfilters[i].ddloprator;
  //     if (!columnname || !columnvalue) {
  //       continue;
  //     }
  //     let displayColumnName = '';
  //     let fieldDataType = '';
  //     let colValArr = [];
  //     for (let i = 0; i < this.columns.length; i++) {
  //       if (this.columns[i].tableColumnName === columnname) {
  //         displayColumnName = this.columns[i].displayColumnName;
  //         fieldDataType = this.columns[i].fieldDataType;
  //         break;
  //       }
  //     }

  //     // ✅ Added: push each filter into criteria array
  //     this.criteria.push({
  //       field: columnname || displayColumnName || '',
  //       keyword: columnvalue || '',
  //       operator: operator || 'AND',
  //     });

  //     if (fieldDataType !== 'date') {
  //       this.searchedWords.push(columnvalue);
  //       if (i == 0) {
  //         colValArr = this.splitColumnValue(
  //           columnvalue,
  //           columnname,
  //           'text',
  //           operator
  //         );
  //         this.searchQueryGrid = `${columnname}:(${columnvalue})`;
  //         this.search_filters.textColumn.push(displayColumnName);
  //         this.search_filters.textValue.push(columnvalue);
  //       } else {
  //         if (operator == 'NOT') {
  //           colValArr = this.splitColumnValue(
  //             columnvalue,
  //             columnname,
  //             'text',
  //             operator
  //           );
  //           this.searchQueryGrid += ` ${operator} ${columnname}:(${columnvalue})`;
  //           this.search_filters.textColumn.push(displayColumnName);
  //           this.search_filters.textValue.push(columnvalue);
  //         }
  //         if (operator == 'AND') {
  //           colValArr = this.splitColumnValue(
  //             columnvalue,
  //             columnname,
  //             'text',
  //             operator
  //           );
  //           this.searchQueryGrid += ` ${operator} ${columnname}:(${columnvalue})`;
  //           this.search_filters.textColumn.push(displayColumnName);
  //           this.search_filters.textValue.push(columnvalue);
  //         } else {
  //           colValArr = this.splitColumnValue(
  //             columnvalue,
  //             columnname,
  //             'text',
  //             operator
  //           );
  //           this.searchQueryGrid += ` ${operator} ${columnname}:(${columnvalue})`;
  //           this.search_filters.textColumn.push(displayColumnName);
  //           this.search_filters.textValue.push(columnvalue);
  //         }
  //       }
  //     } else {
  //       if (i == 0) {
  //         colValArr = this.dateConditionArr(
  //           columnvalue,
  //           columnname,
  //           operator,
  //           i
  //         );
  //         if (columnvalue[1]) {
  //           for (let i = 0; i < this.columns.length; i++) {
  //             if (this.columns[i].tableColumnName === columnname) {
  //               this.searchQueryGrid = `${
  //                 this.columns[i].displayColumnName
  //               }:(${this.datePipe.transform(
  //                 columnvalue[0],
  //                 'dd-MM-yyyy'
  //               )} TO ${this.datePipe.transform(
  //                 columnvalue[1],
  //                 'dd-MM-yyyy'
  //               )})`;
  //               this.search_filters.textColumn.push(columnname);
  //               this.search_filters.textValue.push(columnvalue);
  //               break;
  //             }
  //           }
  //         } else {
  //           for (let i = 0; i < this.columns.length; i++) {
  //             if (this.columns[i].tableColumnName === columnname) {
  //               this.searchQueryGrid = `${
  //                 this.columns[i].displayColumnName
  //               }:(${this.datePipe.transform(columnvalue[0], 'dd-MM-yyyy')})`;
  //               this.search_filters.textColumn.push(columnname);
  //               this.search_filters.textValue.push(columnvalue);
  //               break;
  //             }
  //           }
  //         }
  //       } else {
  //         if (operator == 'NOT') {
  //           colValArr = this.dateConditionArr(
  //             columnvalue,
  //             columnname,
  //             operator,
  //             i
  //           );
  //           if (columnvalue[1]) {
  //             for (let i = 0; i < this.columns.length; i++) {
  //               if (this.columns[i].tableColumnName === columnname) {
  //                 this.searchQueryGrid += ` ${operator} ${
  //                   this.columns[i].displayColumnName
  //                 }:(${this.datePipe.transform(
  //                   columnvalue[0],
  //                   'dd-MM-yyyy'
  //                 )} TO ${this.datePipe.transform(
  //                   columnvalue[1],
  //                   'dd-MM-yyyy'
  //                 )})`;
  //                 this.search_filters.textColumn.push(columnname);
  //                 this.search_filters.textValue.push(columnvalue);
  //                 break;
  //               }
  //             }
  //           } else {
  //             for (let i = 0; i < this.columns.length; i++) {
  //               if (this.columns[i].tableColumnName === columnname) {
  //                 this.searchQueryGrid += ` ${operator} ${
  //                   this.columns[i].displayColumnName
  //                 }:(${this.datePipe.transform(columnvalue[0], 'dd-MM-yyyy')})`;
  //                 this.search_filters.textColumn.push(columnname);
  //                 this.search_filters.textValue.push(columnvalue);
  //                 break;
  //               }
  //             }
  //           }
  //         }
  //         if (operator == 'AND') {
  //           colValArr = this.dateConditionArr(
  //             columnvalue,
  //             columnname,
  //             operator,
  //             i
  //           );
  //           if (columnvalue[1]) {
  //             for (let i = 0; i < this.columns.length; i++) {
  //               if (this.columns[i].tableColumnName === columnname) {
  //                 this.searchQueryGrid += ` ${operator} ${
  //                   this.columns[i].displayColumnName
  //                 }:(${this.datePipe.transform(
  //                   columnvalue[0],
  //                   'dd-MM-yyyy'
  //                 )} TO ${this.datePipe.transform(
  //                   columnvalue[1],
  //                   'dd-MM-yyyy'
  //                 )})`;
  //                 this.search_filters.textColumn.push(columnname);
  //                 this.search_filters.textValue.push(columnvalue);
  //                 break;
  //               }
  //             }
  //           } else {
  //             for (let i = 0; i < this.columns.length; i++) {
  //               if (this.columns[i].tableColumnName === columnname) {
  //                 this.searchQueryGrid += ` ${operator} ${
  //                   this.columns[i].displayColumnName
  //                 }:(${this.datePipe.transform(columnvalue[0], 'dd-MM-yyyy')})`;
  //                 this.search_filters.textColumn.push(columnname);
  //                 this.search_filters.textValue.push(columnvalue);
  //                 break;
  //               }
  //             }
  //           }
  //         } else {
  //           colValArr = this.dateConditionArr(
  //             columnvalue,
  //             columnname,
  //             operator,
  //             i
  //           );
  //           if (columnvalue[1]) {
  //             for (let i = 0; i < this.columns.length; i++) {
  //               if (this.columns[i].tableColumnName === columnname) {
  //                 this.searchQueryGrid += ` ${operator} ${
  //                   this.columns[i].displayColumnName
  //                 }:(${this.datePipe.transform(
  //                   columnvalue[0],
  //                   'dd-MM-yyyy'
  //                 )} TO ${this.datePipe.transform(
  //                   columnvalue[1],
  //                   'dd-MM-yyyy'
  //                 )})`;
  //                 this.search_filters.textColumn.push(columnname);
  //                 this.search_filters.textValue.push(columnvalue);
  //                 break;
  //               }
  //             }
  //           } else {
  //             for (let i = 0; i < this.columns.length; i++) {
  //               if (this.columns[i].tableColumnName === columnname) {
  //                 this.searchQueryGrid += ` ${operator} ${
  //                   this.columns[i].displayColumnName
  //                 }:(${this.datePipe.transform(columnvalue[0], 'dd-MM-yyyy')})`;
  //                 this.search_filters.textColumn.push(columnname);
  //                 this.search_filters.textValue.push(columnvalue);
  //                 break;
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }

  //     //Add And Or conditions
  //     if (operator == 'AND' || operator == 'NOT') {
  //       orArr.length > 0 ? andArr.push({ $or: orArr }) : '';
  //       orArr = [];
  //       orArr.push(...colValArr);
  //     } else {
  //       orArr.push(...colValArr);
  //     }
  //   }
  //   if (orArr.length > 0) {
  //     andArr.push({ $or: orArr });
  //   }
  //   searchCondition.push({ $or: [{ $and: andArr }] });
  //   let tablelevlfiltercondition = this._constant.getTableFilterCondition(
  //     this.primaryTablefilter
  //   );
  //   searchCondition = searchCondition.concat(tablelevlfiltercondition);

  //   // ✅ Return same as before (array)
  //   return searchCondition;
  // }

  // dynamicFilter() {
  //   // debugger;
  //   let searchCondition: any[] = [];
  //   this.search_filters.SeachType = 'Dynamic';
  //   this.search_filters.textColumn = [];
  //   this.search_filters.textValue = [];
  //   this.filterForm.value.dynfilters.forEach((filter: any, i: any) => {
  //     if (filter.txtfiltervaluedyn) {
  //       if (filter.ddlfielddatatypedyn == 'date') {
  //         const [startDate, endDate] = filter.txtfiltervaluedyn;

  //         if (startDate && endDate) {
  //           searchCondition.push({
  //             [filter.ddlfieldnamedyn]: {
  //               $gte: new Date(startDate),
  //               $lte: new Date(endDate),
  //             },
  //           });
  //         } else if (startDate) {
  //           searchCondition.push({
  //             [filter.ddlfieldnamedyn]: { $gte: new Date(startDate) },
  //           });
  //         } else if (endDate) {
  //           searchCondition.push({
  //             [filter.ddlfieldnamedyn]: { $lte: new Date(endDate) },
  //           });
  //         }
  //       } else {
  //         searchCondition.push({
  //           [filter.ddlfieldnamedyn]: {
  //             $regex: filter.txtfiltervaluedyn,
  //             $options: 'i',
  //           },
  //         });
  //       }

  //       this.searchedWords.push(filter.txtfiltervaluedyn);
  //       this.search_filters?.textColumn?.push(filter.ddlfieldnamedyn);
  //       this.search_filters?.textValue?.push(filter.txtfiltervaluedyn);
  //     }
  //   });
  //   let tablelevlfiltercondition = this._constant.getTableFilterCondition(
  //     this.primaryTablefilter
  //   );
  //   searchCondition = searchCondition.concat(tablelevlfiltercondition);
  //   searchCondition = [{ $or: [{ $and: searchCondition }] }];
  //   return searchCondition;
  // }

  // new
  // dynamicFilter() {
  //   // this.searchQueryGrid = getSearchQueryGrid()
  //   let searchCondition: any[] = [];
  //   this.search_filters.SeachType = 'Dynamic';
  //   this.search_filters.textColumn = [];
  //   this.search_filters.textValue = [];
  //   this.filterForm.value.dynfilters.forEach((filter: any, index: any) => {
  //     if (filter.txtfiltervaluedyn) {
  //       if (filter.ddlfielddatatypedyn === 'date') {
  //         const [startDate, endDate] = filter.txtfiltervaluedyn;

  //         // Ensure the field is of type date
  //         searchCondition.push({
  //           $expr: {
  //             $eq: [{ $type: `$${filter.ddlfieldnamedyn}` }, 'date'],
  //           },
  //         });

  //         if (startDate && endDate) {
  //           if (
  //             this.filterForm.value.dynfilters[0].txtfiltervaluedyn ||
  //             this.filterForm.value.dynfilters[1].txtfiltervaluedyn
  //           ) {
  //             this.searchQueryGrid += ` ${filter.ddloprator} ${
  //               filter.ddlfieldnamedyn
  //             } : (${new Date(startDate).toLocaleDateString()} To ${new Date(
  //               endDate
  //             ).toLocaleDateString()})`;
  //           } else {
  //             this.searchQueryGrid += ` ${filter.ddlfieldnamedyn} : (${new Date(
  //               startDate
  //             ).toLocaleDateString()} To ${new Date(
  //               endDate
  //             ).toLocaleDateString()})`;
  //           }

  //           searchCondition.push({
  //             $expr: {
  //               $and: [
  //                 {
  //                   $gte: [
  //                     { $toDate: `$${filter.ddlfieldnamedyn}` },
  //                     { $toDate: startDate },
  //                   ],
  //                 },
  //                 {
  //                   $lte: [
  //                     { $toDate: `$${filter.ddlfieldnamedyn}` },
  //                     { $toDate: endDate },
  //                   ],
  //                 },
  //               ],
  //             },
  //           });
  //         }
  //         // Handle only start date
  //         else if (startDate) {
  //           if (
  //             this.filterForm.value.dynfilters[0].txtfiltervaluedyn ||
  //             this.filterForm.value.dynfilters[1].txtfiltervaluedyn
  //           ) {
  //             this.searchQueryGrid += ` ${filter.ddloprator} ${
  //               filter.ddlfieldnamedyn
  //             } : (${new Date(startDate).toLocaleDateString()})`;
  //           } else {
  //             this.searchQueryGrid += ` ${filter.ddlfieldnamedyn} : (${new Date(
  //               startDate
  //             ).toLocaleDateString()})`;
  //           }
  //           searchCondition.push({
  //             $expr: {
  //               $gte: [
  //                 { $toDate: `$${filter.ddlfieldnamedyn}` },
  //                 { $toDate: startDate },
  //               ],
  //             },
  //           });
  //         }
  //         // Handle only end date
  //         else if (endDate) {
  //           if (
  //             this.filterForm.value.dynfilters[0].txtfiltervaluedyn ||
  //             this.filterForm.value.dynfilters[1].txtfiltervaluedyn
  //           ) {
  //             this.searchQueryGrid += ` ${filter.ddloprator} ${
  //               filter.ddlfieldnamedyn
  //             } : (${new Date(endDate).toLocaleDateString()})`;
  //           } else {
  //             this.searchQueryGrid += ` ${filter.ddlfieldnamedyn} : (${new Date(
  //               endDate
  //             ).toLocaleDateString()})`;
  //           }
  //           searchCondition.push({
  //             $expr: {
  //               $lte: [
  //                 { $toDate: `$${filter.ddlfieldnamedyn}` },
  //                 { $toDate: endDate },
  //               ],
  //             },
  //           });
  //         }
  //       } else {
  //         // Handle text type filters
  //         searchCondition.push({
  //           [filter.ddlfieldnamedyn]: {
  //             $regex: filter.txtfiltervaluedyn,
  //             $options: 'i',
  //           },
  //         });

  //         if (index == 0) {
  //           this.searchQueryGrid += `${filter.ddlfieldnamedyn} : (${filter.txtfiltervaluedyn})`;
  //         } else if (index == 1) {
  //           this.searchQueryGrid += ` ${filter.ddloprator} ${filter.ddlfieldnamedyn} : (${filter.txtfiltervaluedyn})`;
  //         }
  //       }

  //       this.searchedWords.push(filter.txtfiltervaluedyn);
  //       this.search_filters?.textColumn?.push(filter.ddlfieldnamedyn);
  //       this.search_filters?.textValue?.push(filter.txtfiltervaluedyn);
  //     }
  //   });

  //   // Additional table-level filter conditions
  //   let tablelevlfiltercondition = this._constant.getTableFilterCondition(
  //     this.primaryTablefilter
  //   );
  //   searchCondition = searchCondition.concat(tablelevlfiltercondition);
  //   searchCondition = [{ $or: [{ $and: searchCondition }] }];

  //   return searchCondition;
  // }

  getSecondaryTablesData() {
    try {
      // Check if data exists
      if (
        !this.secondaryTableDetails ||
        this.secondaryTableDetails.length === 0
      ) {
        console.warn('No secondary table data found (gbrn_products)');
        return;
      }

      const secTableName = 'gbrn_products';
      const secTableData = Array.isArray(this.secondaryTableDetails)
        ? this.secondaryTableDetails
        : [this.secondaryTableDetails];

      const firstItem = secTableData[0] || {};
      const template = Object.keys(firstItem).map((key) => ({
        field: key,
        header: key,
        visible: true,
      }));
      this.secondaryTableDetails = {
        secondaryTables: {
          [secTableName]: {
            data: secTableData,
            template: template,
            fields: firstItem,
          },
        },
      };

      // Hide any empty columns (optional)
      this.hideColumns();

      console.log(
        '✅ Secondary table data processed locally:',
        this.secondaryTableDetails
      );
    } catch (error) {
      console.error('Error in getSecondaryTablesData:', error);
    }
  }

  getSecondaryTablesDownloadData(downloadData: any) {
    Object.keys(this.secondaryTableDetails.secondaryTables).forEach(
      (secTable) => {
        let searchField =
          this.secondaryTableDetails.secondaryTables[secTable]['findBy'];
        let searchValues: any = new Set([]);
        downloadData.forEach((data: any) => {
          let fieldVal = data[
            this.secondaryTableDetails.secondaryTables[secTable][
              'findByParentField'
            ]
          ].split(
            this.secondaryTableDetails.secondaryTables[secTable][
              'parentFieldSeparator'
            ]
          );
          fieldVal.forEach((val: any) => {
            switch (
              this.secondaryTableDetails.secondaryTables[secTable][
                'findByDataType'
              ]
            ) {
              case 'text':
                searchValues.add(val.toString());
                break;
              case 'number':
                searchValues.add(parseInt(val));
                break;
              default:
            }
          });
        });
        let searchCondition = this.secondaryTableSearchCondition(
          searchField,
          searchValues
        );
        let projectionObj: any = {};
        let secondaryTableTemplate = this.secondaryTableTemplateCondition(
          Object.keys(
            this.secondaryTableDetails.secondaryTables[secTable]['fields']
          )
        );

        this.cols
          .filter((val) => val.tableName === secTable)
          .forEach((col) => (projectionObj[col.field] = 1));
        Object.keys(
          this.secondaryTableDetails.secondaryTables[secTable]['fields']
        ).map((field) => {
          projectionObj[field] = 1;
        });
        projectionObj['activeIngredient'] = 1;
        projectionObj[searchField] = 1;
        let postdata = {
          tableName: secTable,
          templateName:
            this.secondaryTableDetails.secondaryTables[secTable][
              'templateName'
            ],
          projectionObj: projectionObj,
          searchCondition: searchCondition,
          secondaryTemplate: secondaryTableTemplate,
        };

        this.datasearch.get_secondary_table_data(postdata).subscribe(
          (res) => {
            this.secondaryTableDownloadDetails.secondaryTables[secTable].data =
              res.data[0];
            this.secondaryTableDownloadDetails.secondaryTables[
              secTable
            ].template = res.data[1];
            this.secondaryTableDownloadDetails.secondaryTables[
              secTable
            ].template.forEach((field: any) => {
              Object.keys(
                this.secondaryTableDownloadDetails.secondaryTables[secTable]
                  .fields[field.field]
              ).forEach((order) => {
                field[order] =
                  this.secondaryTableDownloadDetails.secondaryTables[
                    secTable
                  ].fields[field.field][order];
              });
            });
          },
          (error) => {
            console.log('error', error);
          }
        );
      }
    );
  }

  secondaryTableSearchCondition(searchField: any, searchValues: any) {
    let searchCondition: any = { $or: [] };
    searchValues.forEach((val: any) => {
      searchCondition['$or'].push({ [searchField]: val });
    });
    return searchCondition;
  }

  secondaryTableTemplateCondition(fields: any) {
    let searchCondition: any = { $or: [] };
    fields.forEach((val: any) => {
      searchCondition['$or'].push({ tableColumnName: val });
    });
    return searchCondition;
  }

  dynSelectedPatentType: string = '';
  setPatentDynFilter(filterform: FormGroup, constrolname: any) {
    this.dynSelectedPatentType = filterform.controls[constrolname].value;
  }

  splitColumnValue(
    columnValue: any,
    columnname: any,
    valType: any,
    operator: any
  ) {
    let colValArr: any = [];

    if (
      columnValue.toLowerCase().indexOf('and') >= 0 ||
      columnValue.toLowerCase().indexOf('or') >= 0
    ) {
      let strArr = columnValue.split(/\sand\s|\sor\s/gi);
      let opStr = columnValue.match(/\b(?:and|or)\b/gi);
      strArr.forEach((str: any, index: any) => {
        colValArr.push({
          operator: index === 0 ? 'AND' : opStr[index - 1].toUpperCase(),
          value: str,
        });
      });
      return valType === 'text'
        ? this.textFieldCondition(colValArr, columnname, operator)
        : this.dateFieldCondition(colValArr, columnname, operator);
    } else {
      colValArr.push({ operator: 'AND', value: columnValue });
      return valType === 'text'
        ? this.textFieldCondition(colValArr, columnname, operator)
        : this.dateFieldCondition(colValArr, columnname, operator);
    }
  }

  textFieldCondition(colValArr: any, columnname: any, operator: any) {
    let andArr: any = [];
    let orArr: any = [];
    colValArr.forEach((val: any, i: any) => {
      let searchWordArr: any = [];
      let searchCondition: any = [];
      searchWordArr.push(val.value.replace(/[^a-zA-Z0-9\s]/g, '\\$&'));
      searchWordArr.push(val.value.replace(/[^\w\s]+/gi, ''));
      searchWordArr.push(val.value.replace(/[^\w\s]+/gi, ' '));
      if (operator === 'NOT') {
        searchWordArr.forEach((text: any) => {
          searchCondition.push({
            [columnname]: { $not: { $regex: text, $options: 'i' } },
          });
        });
      } else {
        searchWordArr.forEach((text: any) => {
          searchCondition.push({
            [columnname]: { $regex: text, $options: 'i' },
          });
        });
      }

      if (i === 0 || val.operator === 'OR') {
        orArr.push({ $or: searchCondition });
      } else {
        andArr.push({ $or: searchCondition });
      }
    });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }

  dateFieldCondition(colValArr: any, columnname: any, operator: any) {
    let andArr: any = [];
    let orArr: any = [];
    colValArr.forEach((val: any, i: any) => {
      let inputValue = val.value.split('TO');
      for (let i = 0; i < inputValue.length; i++) {
        if (inputValue[i].indexOf('*') < 0) {
          let dateArr = inputValue[i].split('-');
          inputValue[i] =
            dateArr[2].trim() +
            '-' +
            dateArr[1].trim() +
            '-' +
            dateArr[0].trim();
        } else {
          inputValue[i] = inputValue[i].trim();
        }
      }
      let searchCondition: any = [];
      if (operator === 'NOT') {
        if (inputValue[1]) {
          if (inputValue[0] === '*') {
            searchCondition.push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else if (inputValue[1] === '*') {
            searchCondition.push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else {
            searchCondition.push({ $and: [] });
            searchCondition[0]['$and'].push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
            searchCondition[0]['$and'].push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          }
        } else {
          searchCondition.push({
            $expr: {
              $ne: [
                { $toDate: `$${columnname}` },
                {
                  $toDate: this.datePipe.transform(inputValue[0], 'yyyy-MM-dd'),
                },
              ],
            },
          });
        }
      } else {
        if (inputValue[1]) {
          if (inputValue[0] === '*') {
            searchCondition.push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else if (inputValue[1] === '*') {
            searchCondition.push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          } else {
            searchCondition.push({ $and: [] });
            searchCondition[0]['$and'].push({
              $expr: {
                $gte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[0],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
            searchCondition[0]['$and'].push({
              $expr: {
                $lte: [
                  { $toDate: `$${columnname}` },
                  {
                    $toDate: this.datePipe.transform(
                      inputValue[1],
                      'yyyy-MM-dd'
                    ),
                  },
                ],
              },
            });
          }
        } else {
          searchCondition.push({
            $expr: {
              $eq: [
                { $toDate: `$${columnname}` },
                {
                  $toDate: this.datePipe.transform(inputValue[0], 'yyyy-MM-dd'),
                },
              ],
            },
          });
        }
      }

      if (i === 0 || val.operator === 'OR') {
        orArr.push({ $or: searchCondition });
      } else {
        andArr.push({ $or: searchCondition });
      }
    });
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }

  dateConditionArr(colValArr: any, columnname: any, operator: any, i: any) {
    let andArr: any = [];
    let orArr: any = [];
    let searchCondition: any = [];
    if (operator === 'NOT') {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $ne: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    } else {
      if (colValArr[1]) {
        searchCondition.push({ $and: [] });
        searchCondition[0]['$and'].push({
          $expr: {
            $gte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
        searchCondition[0]['$and'].push({
          $expr: {
            $lte: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[1], 'yyyy-MM-dd') },
            ],
          },
        });
      } else {
        searchCondition.push({
          $expr: {
            $eq: [
              { $toDate: `$${columnname}` },
              { $toDate: this.datePipe.transform(colValArr[0], 'yyyy-MM-dd') },
            ],
          },
        });
      }
    }

    if (i === 0 || operator === 'OR') {
      orArr.push({ $or: searchCondition });
    } else {
      andArr.push({ $or: searchCondition });
    }
    if (orArr.length > 0) {
      andArr.push({ $or: orArr });
    }
    return andArr;
  }

  exportExcel(extention: any) {
    if (!this.checkUserDownloadPrivillege()) return;

    if (
      !this.currentFilterCondition ||
      this.currentFilterCondition.length === 0
    ) {
      this.busyService.idle();
      return;
    }

    let downloadRecords =
      this.Default_DownloadRec_Limit > this.totalRecords
        ? this.totalRecords
        : this.Default_DownloadRec_Limit;

    let batchSize = 2000;

    for (let i = 0; i < Math.ceil(downloadRecords / batchSize); i++) {
      let limit =
        i + 1 === Math.ceil(downloadRecords / batchSize) &&
        downloadRecords % batchSize !== 0
          ? downloadRecords % batchSize
          : batchSize;

      let postdata = {
        search_type: this.searchType,
        criteria: this.currentFilterCondition || [],
        pagenumber: i + 1,
        rowscount: downloadRecords,
        sortby: this.currentSortBy || '',
        filters: this.getQuery(i + 1, limit),
        subFilters: {},
        activityObj: {
          userId: this.user_data.userid || '',
          privilegeName: 'IPD_SEARCH',
          mode: 'search',
          query: this.searchQueryGrid || '',
          searchFilters: this.search_filters,
          userIp: this.user_ip || '',
          address: this.address || '',
        },
      };

      this.busyService.busy();
      this.datasearch.table_data(postdata).subscribe(
        (res) => {
          let DownloadData = res.data.results;
          this.busyService.idle();

          let visibleCols = this.cols.filter((col) => col.isDisplay == 1);

          let tempData: any[] = [];

          DownloadData.forEach((row: any, index: number) => {
            let rowData: any[] = [];
            row.S_NO = index + 1;

            // Primary array gbrn ko string me convert
            let primaryGbrn = Array.isArray(row.gbrn)
              ? row.gbrn
              : (row.gbrn || '').toString().split(',');

            visibleCols.forEach((col) => {
              let value = '';

              if (!col.from || col.from === 'primary') {
                if (col.fieldDataType === 'image') {
                  value = row[col.field]
                    ? `https://chemrobotics.com/agropat/images/${
                        this.imageBaseUrls[col.field]
                      }${row[col.field]}`
                    : '';
                } else if (col.fieldDataType === 'document') {
                  value = row[col.field]
                    ? `https://chemrobotics.com/agropat/${
                        this.imageBaseUrls[col.field]
                      }${row[col.field]}`
                    : '';
                } else {
                  value = row[col.field] ?? '';
                }
              }

              // 2) Secondary: gbrn_products → Match by gbrn
              else if (col.from === 'secondary') {
                if (row.gbrn_products && Array.isArray(row.gbrn_products)) {
                  let matches: any[] = [];

                  row.gbrn_products.forEach((prod: any) => {
                    let secGbrn = Array.isArray(prod.gbrn)
                      ? prod.gbrn
                      : [prod.gbrn];

                    const matched = secGbrn.some((g: any) =>
                      primaryGbrn.includes(g)
                    );

                    if (matched) {
                      matches.push(prod[col.field] ?? '');
                    }
                  });

                  value = matches.join(', ');
                }
              }

              rowData.push(value);
            });

            tempData.push(rowData);
          });

          // Empty rows remove
          tempData = tempData.filter((row) =>
            row.some(
              (c: any) =>
                c !== null && c !== undefined && c.toString().trim() !== ''
            )
          );

          // Non-empty columns find
          let nonEmptyCols = visibleCols
            .map((_, i) => i)
            .filter((i) =>
              tempData.some(
                (row) =>
                  row[i] !== null &&
                  row[i] !== undefined &&
                  row[i].toString().trim() !== ''
              )
            );

          // Final headers + colors + data
          let headers = nonEmptyCols.map((i) => visibleCols[i].header);
          let bgColors = nonEmptyCols.map((i) =>
            visibleCols[i].columnColor
              ? visibleCols[i].columnColor.replace('#', '')
              : 'ffffff'
          );

          let filteredData = tempData.map((row) =>
            nonEmptyCols.map((i) => row[i])
          );

          let reportData = {
            title: `${this.pageTitile} Data Report`,
            data: filteredData,
            headers: headers,
            bgColors: bgColors,
            sheetname: 'data',
            file_extention: extention,
            searchterm: this.searchQueryGrid,
          };

          this.exportdataService.exportExcel(reportData);
        },
        () => this.busyService.idle()
      );
    }
  }

  async exportPdf() {
    //Check User Privilege
    if (!this.checkUserDownloadPrivillege()) {
      return;
    }

    this.busyService.busy();
    if (this.currentFilterCondition.length == 0) {
      this.busyService.idle();
      return;
    }

    let downloadRecords =
      this.Default_DownloadRec_Limit > this.totalRecords
        ? this.totalRecords
        : this.Default_DownloadRec_Limit;
    let batchSize = 2000;
    for (let i = 0; i < Math.ceil(downloadRecords / batchSize); i++) {
      let limit =
        i + 1 === Math.ceil(downloadRecords / batchSize) &&
        downloadRecords % batchSize !== 0
          ? downloadRecords % batchSize
          : batchSize;
      let filtercondition = this.getQuery(i + 1, limit);
      let postdata = {
        mode: 'EXPORT_DATA',
        tablename: this.TableName,
        templateName: this.secondaryTableDetails.mainTableTemplate,
        filtercondition: filtercondition,
        pagenumber: this.current_pagenumber,
        rowscount: this.Default_DownloadRec_Limit,
        sortby: this.currentSortBy,
        application_query: this.searchQueryGrid,
        search_filters: this.search_filters,
        user_ip: this.user_ip ? this.user_ip : null,
        address: this.address ? this.address : null,
        userid: this.userid,
        appNamePrivelege: this.appNamePrivelege,
        appName: `${this.TableName} Platform`,
        applicationFunction: `${this.TableName}DataSearch`,
        appUrl: `https://www.${this.TableName}.chemrobotics.com/`,
      };

      this.datasearch.table_data(postdata).subscribe(
        (res) => {
          let response: any = res.data;
          response[0].forEach((row: any, index: any) => {
            row.S_NO = index + 1;
            if (typeof row.GBRN !== 'string') {
              row.GBRN = row.GBRN.toString();
            }
          });
          let DownloadData = response[0];
          let bgColor_temp: any = [];
          this.cols.forEach((col) => {
            col.columnColor
              ? bgColor_temp.push(col.columnColor.replace('#', ''))
              : bgColor_temp.push('ffffff');
          });
          this.rptDataForExcel = [];

          let columns = this.cols
            .filter((x) => x.isDisplay == 1)
            .map((col) => ({
              title: col.header,
              dataKey: col.field,
              tableName: col.tableName,
              fieldDataType: col.fieldDataType,
            }));

          DownloadData.forEach((row: any, index: any) => {
            row.S_NO = index + 1;
          });

          DownloadData.forEach((row: any) => {
            let rowValues: any[] = [];
            this.cols.forEach((col) => {
              if (
                !col.tableName ||
                col.tableName === this.secondaryTableDetails.parentTable
              ) {
                if (
                  col.fieldDataType == 'text' ||
                  col.fieldDataType == 'date'
                ) {
                  rowValues.push(row[col.field]);
                } else if (col.fieldDataType == 'image') {
                  row[col.field]
                    ? rowValues.push(
                        'https://chemrobotics.com/agropat/images/' +
                          this.imageBaseUrls[col.field] +
                          row[col.field]
                      )
                    : rowValues.push(row[col.field]);
                } else if (col.fieldDataType == 'document') {
                  row[col.field]
                    ? rowValues.push(
                        'https://chemrobotics.com/agropat/' +
                          this.imageBaseUrls[col.field] +
                          row[col.field]
                      )
                    : row[col.field];
                }
              } else if (
                col.tableName &&
                col.tableName !== this.secondaryTableDetails.parentTable
              ) {
                let secondaryTableData: any[] = [];
                this.secondaryTableDetails.secondaryTables[
                  col.tableName
                ].data.forEach((val: any) => {
                  if (
                    row[
                      this.secondaryTableDetails.secondaryTables[col.tableName]
                        .findByParentField
                    ]
                      .split(
                        this.secondaryTableDetails.secondaryTables[
                          col.tableName
                        ].parentFieldSeparator
                      )
                      .indexOf(
                        val[
                          this.secondaryTableDetails.secondaryTables[
                            col.tableName
                          ].findBy
                        ]
                      ) >= 0
                  ) {
                    if (
                      col.fieldDataType == 'text' ||
                      col.fieldDataType == 'date'
                    ) {
                      secondaryTableData.push(val[col.field]);
                    } else if (col.fieldDataType == 'image') {
                      val[col.field]
                        ? secondaryTableData.push(
                            'https://chemrobotics.com/agropat/images/' +
                              this.imageBaseUrls[col.field] +
                              val[col.field]
                          )
                        : val[col.field];
                    } else if (col.fieldDataType == 'document') {
                      val[col.field]
                        ? secondaryTableData.push(
                            'https://chemrobotics.com/agropat/' +
                              this.imageBaseUrls[col.field] +
                              val[col.field]
                          )
                        : val[col.field];
                    }
                  }
                });
                rowValues.push(secondaryTableData);
              }
            });
            this.rptDataForExcel.push(rowValues);
          });

          let reportData = {
            title: `${this.pageTitile} Data Report`,
            data: this.rptDataForExcel,
            headers: columns,
            bgColors: bgColor_temp,
            sheetname: 'data',
          };

          // this.exportdataService.exportPdf(reportData);
          this.busyService.idle();
        },
        (error) => {
          this.busyService.idle();
          // this.toastr.error('Error occour in download');
        },
        () => {
          this.busyService.idle();
        }
      );
    }
  }

  showFullPageData() {
    this.IsShowFullPageData = true;
  }

  showDialogMaximized(dialog: Dialog) {
    dialog.maximize();
  }

  isShowReadMoreDialog: boolean = false;
  isShowReadMoreSecondaryDialog: boolean = false;
  showPopupBox: boolean = false;
  readMoreColumn: string = '';
  readMoreContent: string = '';
  readMoreSecondaryContent: any = {};

  showReadMore(column: any, content: any, showPopup: any) {
    this.isShowReadMoreDialog = true;
    this.showPopupBox = showPopup;
    this.readMoreColumn = column;
    this.readMoreContent = content.replace(/;/gi, '; ');
    this.readMoreContent = this.readMoreContent.replace(/\n|\r\n/gm, '<br/>');
  }

  showReadMoreSecondaryTable(
    column: any,
    findBy: any,
    findByParentField: any,
    findByDataType: any,
    content: any,
    findByData: any,
    showPopup: any
  ) {
    this.readMoreSecondaryContent.column = column;
    this.readMoreSecondaryContent.findBy = findBy;
    this.showPopupBox = showPopup;
    this.readMoreSecondaryContent.dataType = column.fieldDataType;
    this.readMoreSecondaryContent.data = content
      .filter((row: any) => {
        return findByData.indexOf(row[findBy]) >= 0;
      })
      .map((val: any) => {
        return { findBy: val[findBy], value: val[column.field] };
      });
    this.readMoreColumn = column.header;
    if (column.fieldDataType === 'text') {
      this.readMoreSecondaryContent.data.forEach((data: any) => {
        data.value = data.value.replace(/;/gi, '; ');
        data.value = data.value.replace(/\n|\r\n/gm, '<br/>');
      });
    }
    this.isShowReadMoreSecondaryDialog = true;
  }

  addDataSpace(data: any) {
    return data != null ? data.toString().replace(/;/gi, '; ') : data;
  }

  fultextEscape(value: any) {
    return value != null ? value.replace(/[+\-><\(\)~*\"@]+/gm, ' ') : value;
  }

  getPatentNumber(data: any) {
    let regex_patent = /[A-Z]{2}\d{4,10}/gi;
    if (regex_patent.test(data)) {
      return data.match(regex_patent);
    } else {
      return data;
    }
  }

  checkUserSearchPrivillege(): boolean {
    this.IsFilterAplied = false;

    //Check User Have Access to Search
    if (!this.privilege_json.View) {
      this.is_show_Search_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to view this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todaySearchCount =
      Number(this.privilege_json.today_search_count) || 0;
    const dailySearchLimit = Number(this.privilege_json.DailySearchLimit) || 0;
    if (todaySearchCount >= dailySearchLimit) {
      this.is_show_Daily_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily search limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const searchCount = Number(this.privilege_json.Search) || 0;
    if (searchCount <= 0) {
      this.is_show_Total_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available search limit.',
      });
      return false;
    }

    this.IsFilterAplied = true;
    this.privilege_json.Search = searchCount - 1;
    this.privilege_json.today_search_count = todaySearchCount + 1;

    // Save updated counts to localStorage
    const userid = this.user_data?.userid || 'guest';
    const dailyKey = `user_${userid}_daily_counts`;

    const today = new Date().toDateString();
    localStorage.setItem(
      dailyKey,
      JSON.stringify({
        date: today,
        today_search_count: this.privilege_json.today_search_count,
        today_download_count: this.privilege_json.today_download_count || 0,
      })
    );
    return true;
  }

  checkUserDownloadPrivillege(): boolean {
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    if (todayDownloadCount >= dailyDownloadLimit) {
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    if (downloadCount <= 0) {
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    return true;
  }

  //#endregion
  resetSearch() {
    this.tableService.sendShowTable(false);
    this.isQueryOptionSelected = false;
    this.dynSelectedPatentType = '';
    this.searchQueryGrid = '';
    this.products_current_datasource = [];
    this.totalRecords = 0;
    this.tablefilter = {};
    this.currentSortBy = '';
    this.backToListQuery = '';
    this.dateValue = {};
    this.oldSearchQueryGrid = '';
    this.isShowQueryBox1 = false;
    this.IsSuggestedItemClick = false;
    this.SuggestedDbColumn = '';
    this.loadColumnDetails();
  }

  //#endregion
  showRaiseQuery() {
    let email: any = JSON.parse(
      localStorage.getItem('currentUser') ?? '{}'
    ).email;
    this.form_RaiseQuery.controls['txtResponseEmail'].setValue(email);
    this.form_RaiseQuery.controls['txtQuery'].setValue('');
    this.isShowRaiseQuery = true;
  }

  sendQuery() {
    let emailPostData = {
      to: 'support@chemrobotics.com',
      subject: 'ChemRobotics - ChemiTracker - User Query',
      html: `
            <div style="background-color: #ffc702; heigth:30px; text-align: center;">
            <img src="cid:logoImg" alt="Logo">
            </div>
            <div style="background-color: #eee;">
            <p>User Email: (<strong>${this.form_RaiseQuery.controls['txtResponseEmail'].value}</strong>)</p>
            <p>User Comment: <strong>${this.form_RaiseQuery.controls['txtQuery'].value}</strong></p>
            <p>Search Query:</p>
            </div>
            <p>${this.searchQueryGrid}</p>
            <div style="background-color: #eee;">
            <p>Thank You!</p>
            <p>Team ChemRobotics</p>
            <p><img src="cid:logoImg" alt="Logo"></p>
            <p><strong>✉️ support@chemrobotics.com</strong></p>
            <p><strong>📞 +91-6266117944</strong>, <strong>+91-9407360810</strong></p>
            </div>
            <hr>
            <div style="background-color: #eee; text-align: center;">
            <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
            <div/>`,
    };
    let postdata = {
      mode: 'ADD_USER_QUERY',
      userid: this.userid,
      usercomment: this.form_RaiseQuery.controls['txtQuery'].value,
      searchquery: this.search_filters,
    };
    this.datasearch.userMasterManage(postdata).subscribe((res) => {});
    this.datasearch.sendMail(emailPostData).subscribe((res) => {
      this.isShowRaiseQuery = false;
      // this.toastr.success('Query raised successfully!', 'Success!');
    });
  }

  backToResult() {
    this.searchQueryGrid = this.backToListQuery;
    this.tablefilter = {};
    this.currentSortBy = '';
    // this.searchQuery();
    this.tableService.sendSearchType(this.backToList.searchType);
    this.tableService.sendBackToList(this.backToList);
    // this.Search();

    this.globalService.backToResult.next(false);
  }

  showDetailView() {
    this.tableService.sendProductDetailView(!this.productDetailView);
  }

  // setIpandLocation() {
  //   this.dataserachService.getIpandLocation().subscribe({
  //     next: (res) => {
  //       this.user_ip = res.userip;
  //       this.address = res.address;
  //     },
  //   });
  // }

  // handlePageLimit() {
  //   this.pageLimitInPrivilegeJson = this.privilege_json.PageLimit
  //     ? this.privilege_json.PageLimit
  //     : 0;
  // }

  // getSecondaryTables() {
  //   let postdata = {
  //     tableName: this.TableName,
  //   };
  //   this.datasearch.get_secondary_table_details(postdata).subscribe((res) => {
  //     this.tableService.sendSecondaryTableDetails(res);
  //   });
  // }
  getImagesBasePath() {
    this.datasearch.getImagesBaseUrl().subscribe((res) => {
      let imageUrls: any = {};
      res.data.forEach((data: any) => {
        imageUrls[data.field] = data.url;
      });
      this.tableService.sendImagesBaseUrl(imageUrls);
    });
  }

  // Hide columns if columns not have data
  hideColumns() {
    const isEmpty = (value: any) => {
      if (value === null || value === undefined) return true;
      if (typeof value === 'string' && value.trim() === '') return true;
      if (Array.isArray(value) && value.length === 0) return true;
      return false;
    };

    this.cols.forEach((col) => {
      // Always show S_NO
      if (col.field === 'S_NO') {
        col.isDisplay = 1;
        return;
      }

      // Check primary data
      const hasPrimaryData = this.products_current_datasource.some((row) => {
        const value = row[col.field];
        return !isEmpty(value);
      });

      // Check secondary data (gbrn_products) for specific fields
      let hasSecondaryData = false;
      if (
        col.field === 'iupac' ||
        col.field === 'casRn' ||
        col.field === 'chemicalClass' ||
        col.field === 'mechanismOfActionMoa' ||
        col.field === 'chemicalStructure' ||
        col.field === 'indication'
      ) {
        hasSecondaryData = this.products_current_datasource.some((row) => {
          if (row.gbrn_products && Array.isArray(row.gbrn_products)) {
            return row.gbrn_products.some(
              (prod: any) => !isEmpty(prod[col.field])
            );
          }
          return false;
        });
      }

      const hasData = hasPrimaryData || hasSecondaryData;
      col.isDisplay = hasData ? 1 : 0;
    });

    const visibleCols = this.cols.filter((c) => c.isDisplay === 1);
  }

  parseSearchQuery(query: string): string {
    const regex = /ACTIVE\s*INGREDIENT\s*:\s*\(([^)]+)\)/gi;
    let matches: string[] = [];
    let match;

    while ((match = regex.exec(query)) !== null) {
      matches.push(match[1].toUpperCase());
    }

    let result = query;
    let placeholderIndex = 0;

    result = result.replace(regex, () => `{{${placeholderIndex++}}}`);

    matches.forEach((val, i) => {
      result = result.replace(`{{${i}}}`, val);
    });

    return result;
  }

  handlePageLimit() {
    this.pageLimitInPrivilegeJson = this.privilege_json.PageLimit
      ? Number(this.privilege_json.PageLimit)
      : 0;
  }

  getImageUrl(col: any, fileName: string): string {
    if (!fileName) return '';
    const header = col.header ? col.header.toLowerCase() : '';
    if (header.includes('company logo')) {
      return 'https://chemrobotics.com/agropat/images/innovators_logo/' + fileName;
    }
    if (header.includes('category image')) {
      return 'https://chemrobotics.com/agropat/images/agro_pro_dir/product_image1/' + fileName;
    }
    const baseUrl = this.imageBaseUrls[col.field] ? this.imageBaseUrls[col.field] : '';
    return 'https://chemrobotics.com/agropat/images/' + baseUrl + fileName;
  }
}
